import { errorMessages } from '@meta/errorMessages'

export default function getErrorMessage(error) {
  let errorMessage = 'Something went wrong, please contact support.'
  if (error.response) {
    errorMessage = errorMessages.default
    // 500 - Internal server error || 404 - URL not found
    if (error.response.status && error.response.status !== 500 &&
      error.response.status !== 404) {
      const isValidationError = error.response?.data?.errors

      if (isValidationError) {
        // ValidationError
        errorMessage = error.response?.data?.errors[0]?.detail

      } else {
        // Serializer error
        errorMessage = error.response?.data[Object.keys(error.response?.data)[0]][0]
      }
    } else {
      // ToDo send as error log
    }
  }
  return errorMessage
}
